
export default function PurposeSection() {
  const purposes = [
    {
      icon: 'ri-heart-line',
      title: 'Transparência Total',
      description: 'Processo claro e transparente em todas as etapas, sem taxas ocultas ou surpresas.'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Máxima Segurança',
      description: 'Trabalhamos apenas com fundos regulamentados e de alta credibilidade no mercado.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Agilidade Garantida',
      description: 'Processo otimizado para que você receba seu dinheiro no menor tempo possível.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Atendimento Humanizado',
      description: 'Cada cliente é único e merece um atendimento personalizado e dedicado.'
    }
  ];

  return (
    <section id="proposito" className="py-24 bg-gray-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-yellow-400 to-blue-600"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header Section */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-500 rounded-full mb-8 mx-auto">
            <i className="ri-lightbulb-line text-3xl text-gray-900"></i>
          </div>
          <h2 className="text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Nosso Propósito
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Transformamos a experiência de venda de precatórios, oferecendo soluções inovadoras 
            que priorizam a confiança, segurança e satisfação dos nossos clientes.
          </p>
        </div>
        
        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {purposes.map((purpose, index) => (
            <div 
              key={index} 
              className="group relative bg-gradient-to-br from-gray-700 to-gray-800 p-8 rounded-2xl border border-gray-600 hover:border-yellow-500 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl"
            >
              {/* Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/10 to-blue-600/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="relative z-10">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-yellow-500 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${purpose.icon} text-2xl text-gray-900`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-yellow-400 transition-colors duration-300" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {purpose.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed text-lg" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                      {purpose.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Bottom CTA Section */}
        <div className="text-center bg-white rounded-3xl p-12 shadow-2xl">
          <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Pronto para transformar seu precatório em dinheiro?
          </h3>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Junte-se aos nossos clientes satisfeitos e descubra como é fácil e seguro vender seu precatório.
          </p>
          <button 
            onClick={() => window.open('https://wa.me/5531972176645?text=Olá! Quero saber mais sobre como vender meu precatório com segurança.', '_blank')}
            className="bg-gray-900 hover:bg-gray-800 text-white font-bold px-12 py-4 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            <i className="ri-message-3-line mr-3"></i>
            Fale Conosco Agora
          </button>
        </div>
      </div>
    </section>
  );
}
